var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.option)?_c('div',{staticClass:"issue_status"},[_c('em'),_c('em',[_vm._v(_vm._s(_vm.option.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }